import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * send mail provider
 */

const sendEmailProvider = (payload) =>
  Vue.$http.post(`purchase/quotation/send-mail/`, payload)
    .then()
    .catch(err => {
      throw err
    })

export default sendEmailProvider


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/sendEmailProvider.js